import { fetch_request } from '../../../service/request';

const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const toServerSeqOrNull = (value) => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  const normalized = Math.trunc(parsed);
  return normalized > 0 ? normalized : null;
};

export const publishMessengerV2ReadReceipt = async ({
  conversationId,
  lastDeliveredServerMsgId = null,
  lastDecryptedServerMsgId = null,
  lastReadServerMsgId = null,
  lastDeliveredServerSeq = null,
  lastDecryptedServerSeq = null,
  lastReadServerSeq = null,
} = {}) => {
  const normalizedConversationId = toStringOrNull(conversationId);
  const normalizedLastDeliveredServerMsgId = toStringOrNull(lastDeliveredServerMsgId);
  const normalizedLastDecryptedServerMsgId = toStringOrNull(lastDecryptedServerMsgId);
  const normalizedLastReadServerMsgId = toStringOrNull(lastReadServerMsgId);
  const normalizedLastDeliveredServerSeq = toServerSeqOrNull(lastDeliveredServerSeq);
  const normalizedLastDecryptedServerSeq = toServerSeqOrNull(lastDecryptedServerSeq);
  const normalizedLastReadServerSeq = toServerSeqOrNull(lastReadServerSeq);

  if (!normalizedConversationId) {
    throw new Error('conversationId is required');
  }
  if (
    !normalizedLastDeliveredServerMsgId &&
    !normalizedLastDecryptedServerMsgId &&
    !normalizedLastReadServerMsgId &&
    normalizedLastDeliveredServerSeq == null &&
    normalizedLastDecryptedServerSeq == null &&
    normalizedLastReadServerSeq == null
  ) {
    return null;
  }

  const response = await fetch_request(
    `/api/conversations/${normalizedConversationId}/read_receipts`,
    {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...(normalizedLastDeliveredServerMsgId
          ? { last_delivered_server_msg_id: normalizedLastDeliveredServerMsgId }
          : {}),
        ...(normalizedLastDecryptedServerMsgId
          ? { last_decrypted_server_msg_id: normalizedLastDecryptedServerMsgId }
          : {}),
        ...(normalizedLastReadServerMsgId
          ? { last_read_server_msg_id: normalizedLastReadServerMsgId }
          : {}),
        ...(normalizedLastDeliveredServerSeq != null
          ? { last_delivered_server_seq: normalizedLastDeliveredServerSeq }
          : {}),
        ...(normalizedLastDecryptedServerSeq != null
          ? { last_decrypted_server_seq: normalizedLastDecryptedServerSeq }
          : {}),
        ...(normalizedLastReadServerSeq != null
          ? { last_read_server_seq: normalizedLastReadServerSeq }
          : {}),
      }),
    },
  );

  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }

  const payload =
    typeof response.json === 'function' ? await response.json().catch(() => null) : null;
  const hasAuthoritativePayload = payload && typeof payload === 'object';

  return {
    conversationId: normalizedConversationId,
    lastDeliveredServerMsgId:
      toStringOrNull(payload?.last_delivered_server_msg_id) ||
      (hasAuthoritativePayload ? null : normalizedLastDeliveredServerMsgId),
    lastDecryptedServerMsgId:
      toStringOrNull(payload?.last_decrypted_server_msg_id) ||
      (hasAuthoritativePayload ? null : normalizedLastDecryptedServerMsgId),
    lastReadServerMsgId:
      toStringOrNull(payload?.last_read_server_msg_id) ||
      (hasAuthoritativePayload ? null : normalizedLastReadServerMsgId),
    lastDeliveredServerSeq:
      toServerSeqOrNull(payload?.last_delivered_server_seq) ??
      (hasAuthoritativePayload ? null : normalizedLastDeliveredServerSeq),
    lastDecryptedServerSeq:
      toServerSeqOrNull(payload?.last_decrypted_server_seq) ??
      (hasAuthoritativePayload ? null : normalizedLastDecryptedServerSeq),
    lastReadServerSeq:
      toServerSeqOrNull(payload?.last_read_server_seq) ??
      (hasAuthoritativePayload ? null : normalizedLastReadServerSeq),
    unreadCount:
      payload?.unread_count == null ? null : Math.max(0, Number(payload.unread_count) || 0),
  };
};

export default publishMessengerV2ReadReceipt;
